<section id="set" style="background-image: url(../assets/images/signin_01.jpg); height: 100%; background-position: center;
    background-repeat: no-repeat; background-size: cover; overflow: hidden;">
    <div class="container d-flex flex-column">
        <div class="row align-items-center justify-content-center g-0  min-vh-100">
            <div class="col-8 col-sm-8 col-md-5 col-xxl-4 py-8 py-xl-0">
                <!-- Card -->
                <div class="card shadow p-3 mb-5 rounded-3 animate__animated animate__fadeInUp">
                    <!-- Card body -->
                    <div class="card-body p-6">
                        <div class="mb-4">
                            <img src="../../assets/images/mcrb_blue.png" class="mb-2" alt="mtropol corporation logo"
                                style="width: 12rem;">
                            <p class="mb-6" style="color: #6c757d;margin-top: .5rem; margin-bottom: 3rem;">
                                <small class="form-text text-muted my-2">
                                    Your password must be 8-20 characters long, contain letters (small and uppercase),
                                    special
                                    characters and numbers, and must not contain spaces, or emoji.
                                </small>
                            </p>
                        </div>
                        <!-- Form -->
                        <form autocomplete="off" [formGroup]="form" (ngSubmit)="submit(form.value)">
                            <div class="form-group" formGroupName="passwords">
                                <!-- Password -->
                                <div class="mb-3">
                                    <label for="password" class="form-label">Password</label>
                                    <input type="password" id="password" class="form-control" formControlName="password"
                                        name="password" placeholder="Enter password"
                                        [class.is-invalid]="isPasswordInvalid || isPasswordStrengthInvalid || isPasswordMatchInvalid">
                                    <!-- error messages -->
                                    <small class="form-text text-danger"
                                        *ngIf="isPasswordInvalid || isPasswordStrengthInvalid || isPasswordMatchInvalid">
                                        <div *ngIf="isPasswordInvalid">A password is required</div>
                                        <div *ngIf="isPasswordStrengthInvalid">Password strength is poor</div>
                                        <div *ngIf="isPasswordMatchInvalid">Passwords do not match</div>
                                    </small>
                                </div>
                                <!-- Confirm Password -->
                                <div class="mb-3">
                                    <label for="confirmpassword" class="form-label">Confirm Password</label>
                                    <input type="password" id="confirmpassword" class="form-control"
                                        formControlName="confirmpassword" name="confirmpassword"
                                        placeholder="Confirm password"
                                        [class.is-invalid]="isConfirmPasswordInvalid || isPasswordMatchInvalid">
                                    <!-- error messages -->
                                    <small class="form-text text-danger"
                                        *ngIf="isConfirmPasswordInvalid || isPasswordMatchInvalid">
                                        <div *ngIf="isConfirmPasswordInvalid">A password is required</div>
                                    </small>
                                </div>
                            </div>
                            <div>
                                <!-- Button -->
                                <div class="d-grid">
                                    <button type="submit" class="btn btn-primary mt-2"
                                        [disabled]="form.invalid || isLoading">
                                        Submit Password
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                                            aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>